<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
body, html {
  width: 100%;
  height: 100px;
}
</style>
